import { ArrowRight, Clock3, MapPin } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useMealPeriod } from '@/hooks/useMealPeriod';
import { CATEGORY_META } from '@/lib/menu';

export function AboutCta() {
  const info = useMealPeriod();

  return (
    <section id="about" className="scroll-mt-20 py-16 sm:py-20">
      <div className="container">
        <div className="relative isolate overflow-hidden rounded-[2rem] bg-secondary px-6 py-14 text-secondary-foreground shadow-2xl shadow-leaf/20 sm:px-12 lg:px-16">
          {/* Decorative pattern */}
          <div
            className="pattern-kitenge pointer-events-none absolute -right-10 -top-10 size-72 rotate-12 text-secondary-foreground/10"
            aria-hidden
          />
          <div
            className="pattern-kitenge pointer-events-none absolute -bottom-16 -left-10 size-64 -rotate-12 text-secondary-foreground/10"
            aria-hidden
          />

          <div className="relative grid items-center gap-10 lg:grid-cols-[1.2fr_0.8fr]">
            <div>
              <p className="text-sm font-bold uppercase tracking-[0.2em] text-marigold">Karibu MLO</p>
              <h2 className="mt-3 font-display text-4xl font-black leading-tight tracking-tight sm:text-5xl">
                Home-cooked Kenyan flavour, without the dishes.
              </h2>
              <p className="mt-4 max-w-xl text-lg leading-relaxed text-secondary-foreground/80">
                MLO means "a meal" — and that's our whole mission: one proper Kenyan meal,
                cooked fresh on the charcoal jiko and delivered while it's still steaming.
                From mandazi at sunrise to nyama choma after dark, tuko na uko covered.
              </p>

              <div className="mt-6 flex flex-wrap gap-x-6 gap-y-2 text-sm font-semibold text-secondary-foreground/80">
                <span className="flex items-center gap-2">
                  <MapPin className="size-4 text-marigold" />
                  Kimathi Street, Nairobi
                </span>
                <span className="flex items-center gap-2">
                  <Clock3 className="size-4 text-marigold" />
                  Open daily · 5:00 AM – midnight EAT
                </span>
              </div>

              <Button
                size="lg"
                onClick={() => document.getElementById('menu')?.scrollIntoView({ behavior: 'smooth' })}
                className="mt-8 rounded-full bg-marigold px-7 text-base font-black text-accent-foreground shadow-lg shadow-black/20 hover:bg-marigold/90"
              >
                Order {CATEGORY_META[info.menuCategory].label.toLowerCase()} now
                <ArrowRight className="size-4" />
              </Button>
            </div>

            <div className="grid grid-cols-2 gap-4">
              {[
                { value: '27+', label: 'Kenyan dishes' },
                { value: '30–45', label: 'min delivery' },
                { value: '2', label: 'ways to pay instantly' },
                { value: '12k+', label: 'happy reviews' },
              ].map((stat) => (
                <div
                  key={stat.label}
                  className="rounded-2xl border border-secondary-foreground/15 bg-secondary-foreground/5 p-5 text-center backdrop-blur-sm"
                >
                  <p className="font-display text-3xl font-black text-marigold">{stat.value}</p>
                  <p className="mt-1 text-xs font-semibold uppercase tracking-wide text-secondary-foreground/70">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
